//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDetail, repairConfirm } from '@/api/PMS/repairManagement/repair';
export default {
  data: function data() {
    return {
      childData: {},
      submitList: {
        confirmFlag: 1,
        repairId: '',
        remark: ''
      }
    };
  },
  props: ['keyValue', 'flowNum', 'showDialog'],
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.submitList.remark = '';
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue,
          flowNum: this.flowNum
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    handPass: function handPass() {
      var _this2 = this;

      if (this.keyValue > 0) {
        this.submitList.confirmFlag = 1;
        this.submitList.verifyStatus = this.childData.flowStatus;
        this.submitList.repairId = this.keyValue;
        repairConfirm(this.submitList).then(function () {
          _this2.$emit('handCancle', 'repairConfirm');

          _this2.Alert({
            alertType: 'add',
            message: '确认完成通过'
          });
        });
      }
    },
    handUnPass: function handUnPass() {
      var _this3 = this;

      if (this.keyValue > 0) {
        this.submitList.confirmFlag = 2;
        this.submitList.verifyStatus = this.childData.flowStatus;
        this.submitList.repairId = this.keyValue;
        repairConfirm(this.submitList).then(function () {
          _this3.$emit('handCancle', 'repairConfirm');

          _this3.Alert({
            alertType: 'add',
            message: '确认完成未通过'
          });
        });
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairConfirm');
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};